export default __webpack_public_path__ + "static/media/Ellipse25.3ae3cb26.png";